import { SelectOptGroupProps } from './select.type';

export const SelectOptGroup = ({ children, ...props }: SelectOptGroupProps) => {
  return <optgroup {...props}>{children}</optgroup>;
};
